export enum SituacaoObraUnicaEnum {

  Aprovado = "Aprovado pelo Fisco",
  Corrigido = "Aprovado com correções do Fisco",
  Reprovado = "Reprovado pelo Fisco",
  SemAnalise = "Sem Analise do Fisco"
}
